
import { defineComponent } from 'vue'
import { useUser } from '@/swr/swr.user'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  setup() {
    const { t } = useI18n()
    return { ...useUser(), t }
  },
})
